<template>
  <div class="application-action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" label-width="90px">
        <el-form-item label="排序:" prop="">
          <el-input size="small" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="应用名称:" prop="">
          <el-input size="small" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="应用链接:" prop="">
          <el-input size="small" placeholder="请输入应用链接"></el-input>
        </el-form-item>
        <el-form-item label="图标:" prop="cover">
          <base-upload :cover="params.cover" :action="action" @successCallback="successCallback" :wSize="360" :hSize="640" :width="'120px'" :height="'113px'"></base-upload>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="params.isActive"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      title: '',
      flag: false,
      dialogVisible: false,
      params: {
        isActive: false,
        recommendTime: '',
        data: '',
        cover: ''
      },
      // 封面上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
    }
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false
    },
     // 封面图上传成功回调
    successCallback(res) {
      this.params.cover = res.data.coverImg
    },
    open(type, row) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑今日'
        window.console.log(row)
      }
    }
  }
}
</script>
<style scoped>
  .el-input {
    width: 220px;
  }
</style>